$(function () {
  let section = $('#cuenta-cambiar-acceso')
  if (section.get(0) == null) {
    return
  }

  let vueApp = new Vue({
    el: section.get(0),
    data: {

    },
    mounted() {
      vueApp = this
      this.validar()
    },
    methods: {
      validar(){
        $('#formPassword').validarForm((form) => {
          vueApp.guardar(form)
        })
      },
      guardar(form){
        $("#btnPassword").loader("show")
        var formData = new FormData(form)
        axios
          .post("/mi-perfil/actualizar-password", formData)
          .then((respuesta) => {
            $("#btnPassword").loader("hide")
            if (respuesta.data.error) {
              swal({
                icon: "info",
                title: respuesta.data.error,
                button: {
                  text: "Aceptar",
                  closeModal: true,
                },
              })
              return
            }
            $('#formPassword')[0].reset();
            swal({
              icon: "success",
              title: "Información actualizada correctamente",
              button: {
                text: "Aceptar",
                closeModal: true,
              },
            })
          })
          .catch((error) => {
            ReportErrorLog(error)
            console.error(error)
            $("#btnPassword").loader("hide")
            swal({
              icon: "info",
              title: "Ocurrió un error inesperado",
              button: {
                text: "Aceptar",
                closeModal: true,
              },
            })
          })
      }
    }
  });
});
